import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  pasteTruncatedWarning: {
    id: 'textAreaField.pasteTruncatedWarning',
    defaultMessage: '⚠ Liitetty teksti oli liian pitkä ja on lyhennetty {maxLength} merkkiin',
  },
})
